<template>
  <div>
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->

          <!-- Search -->
          <b-col cols="12" lg="8">
            <b-row class="align-items-center">
              <b-col lg="6" md="6">
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model.trim="searchQuery"
                    @keyup.enter="onSearch()"
                    class="d-inline-block round"
                    :placeholder="$t('textPlaceholderSearchLocation')"
                  />
                </div>
              </b-col>
              <b-col
                cols="12"
                md="4"
                lg="4"
                class="d-flex align-items-center justify-content-center justify-content-lg-start p-0 my-1 m-lg-0"
              >
                <b-button
                  class="round px-5"
                  variant="primary"
                  :disabled="searchQuery ? false : true"
                  @click="onSearch"
                >
                  {{ $t("search") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>

          <b-col
            cols="12"
            lg="4"
            class="d-flex align-items-center justify-content-end justify-content-xs-start mb-md-0"
          >
            <b-button class="round" variant="primary" @click="New()">
              {{ $t("newLocation") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-table responsive fixed hover :items="items" :fields="fields">
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{
              width:
                field.key === 'detail_address'
                  ? '320px'
                  : field.key === 'actions' ||
                    field.key === 'modified_date' ||
                    field.key === 'STATUS'
                  ? '100px'
                  : '180px',
            }"
          />
        </template>
        <template #cell(status)="row">
          <span
            class="round"
            :class="row.item.status == 1 ? 'status-succes' : 'status-witing'"
          >
            {{ row.item.status == 1 ? $t("approved") : $t("approving") }}
          </span>
        </template>

        <template #cell(actions)="row">
          <b-button
            v-b-tooltip.hover.left="$t('editLocation')"
            variant="primary"
            v-if="buttomDisabled(row.item)"
            size="sm"
            @click="Edit(row.item, row.index, $event.target)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
            v-b-tooltip.hover.left="$t('deleteLocation')"
            variant="danger"
            size="sm"
            @click="Delete(row.item, row.index, $event.target)"
            v-if="
              userData.role == 'CLIENT'
                ? row.item.user_id == userData.username
                : true
            "
          >
            <feather-icon icon="DeleteIcon" />
          </b-button>
        </template>
      </b-table>
      <b-row class="pl-2 pr-2 pb-1 pt-1 border-top">
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t("showing") }}</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            style="min-width: 60px"
            class="per-page-selector select-size-sm d-inline-block ml-50 mr-1"
          />
          <label>{{ $t("entries") }}</label>
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
        >
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="modalShow"
      no-close-on-backdrop
      size="xl"
      :title="modal_title"
      @ok="handleOk"
    >
      <validation-observer ref="simpleRulesModal">
        <b-row>
          <b-col cols="7">
            <b-col
              cols="12"
              class="pt-1 px-0"
              v-if="isAdmin && this.$i18n.t('newLocation') == modal_title"
            >
              <validation-provider
                :name="$t('chooseListCompany')"
                #default="{ errors }"
                rules="required"
              >
                <b-form-group>
                  <label
                    >{{ $t("chooseListCompany") }}
                    <span class="required">*</span>
                  </label>

                  <Select4
                    :key="company_list.length"
                    v-model="company_id"
                    :classProp="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Select Company"
                    @reload="loadCompany"
                    :options="{
                      isSearch: true,
                      isReload: true,
                      value: 'code',
                      label: 'name',
                      data: company_list,
                      fields: [
                        { field: 'code', label: 'Tax Code' },
                        { field: 'name', label: 'Name' },
                        {
                          field: 'acronym',
                          label: 'Acronym',
                        },
                      ],
                    }"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-row v-if="isAdmin ? company_id : true">
              <b-col cols="6" v-if="isAdmin">
                <validation-provider
                  :name="$t('user')"
                  #default="{ errors }"
                  :rules="{ required: 'required', vselect: true }"
                >
                  <b-form-group>
                    <label
                      >{{ $t("user") }}<span class="required">*</span>
                    </label>

                    <!-- <multiselect
                      v-model="user"
                      :options="customer_list_options"
                      :class="{ 'has-error': errors[0] }"
                      :state="errors.length > 0 ? false : null"
                      :searchable="true"
                      :show-labels="false"
                      :placeholder="$t('enterSelect')"
                      label="text"
                      track-by="text"
                    >
                    </multiselect> -->
                    <Select4
                      v-model="user"
                      :classProp="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Select Company"
                      @reload="loadCustomerList"
                      :options="{
                        isSearch: true,
                        isReload: true,
                        value: 'code',
                        all: true,
                        label: 'name',
                        data: customer_list_options,
                        fields: [
                          { field: 'code', label: 'Tax Code' },
                          { field: 'name', label: 'Name' },
                        ],
                      }"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col :cols="isAdmin ? 6 : 12" v-if="isShowEdit">
                <validation-provider
                  name="Location"
                  #default="{ errors }"
                  :rules="{
                    required: 'required',
                    vselect: !anotherLocation ? true : false,
                  }"
                >
                  <b-form-group>
                    <label
                      >{{ $t("chooseListLocation")
                      }}<span v-show="!anotherLocation" class="required"
                        >*</span
                      >
                    </label>
                    <!-- <multiselect
                      v-model="location"
                      :options="locations"
                      :disabled="anotherLocation"
                      :class="{ 'has-error': errors[0] }"
                      :state="errors.length > 0 ? false : null"
                      :searchable="true"
                      :show-labels="false"
                      :placeholder="$t('enterSelect')"
                      label="text"
                      track-by="text"
                    >
                    </multiselect> -->
                    <Select4
                      v-model="location"
                      :classProp="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="anotherLocation"
                      placeholder="Select Company"
                      @reload="fetchLocationOption"
                      :options="{
                        isSearch: true,
                        isReload: true,
                        value: 'id',
                        all: true,
                        label: 'name',
                        data: locations,
                        fields: [
                          { field: 'name', label: 'Name' },
                          { field: 'abbreviations', label: 'Abbreviations' },
                        ],
                      }"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                <b-form-group v-if="isShowEdit" class="mb-0">
                  <b-form-checkbox switch v-model="anotherLocation">
                    {{ $t("anotherLocation") }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="anotherLocation">
              <b-col cols="6">
                <validation-provider
                  :name="$t('Abbreviations')"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label
                      >{{ $t("Abbreviations") }}<span class="required">*</span>
                    </label>

                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      v-model="abbreviations"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  :name="$t('Location')"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label
                      >{{ $t("Location") }}<span class="required">*</span>
                    </label>

                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      v-model="locationInput"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  :name="$t('region')"
                  #default="{ errors }"
                  :rules="{ required: 'required' }"
                >
                  <b-form-group>
                    <label
                      >{{ $t("region") }}<span class="required">*</span>
                    </label>
                    <!-- <multiselect
                      v-model="region"
                      :options="regions"
                      :class="{ 'has-error': errors[0] }"
                      :state="errors.length > 0 ? false : null"
                      :searchable="true"
                      :show-labels="false"
                      label="text"
                      track-by="text"
                    >
                    </multiselect> -->
                    <Select4
                      v-model="region"
                      :classProp="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Select region"
                      @reload="loadRegion"
                      :options="{
                        isSearch: true,
                        isReload: true,
                        value: 'id',
                        all: true,
                        label: 'text',
                        data: regions,
                        fields: [{ field: 'text', label: 'text' }],
                      }"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  :name="$t('locationType')"
                  #default="{ errors }"
                  :rules="{ required: 'required', vselect: true }"
                >
                  <b-form-group>
                    <label
                      >{{ $t("locationType") }} <span class="required">*</span>
                    </label>
                    <!-- <multiselect
                      :key="locationTypeId"
                      v-model="locationTypeId"
                      :options="getLocationTypes"
                      :class="{ 'has-error': errors[0] }"
                      :state="errors.length > 0 ? false : null"
                      :searchable="true"
                      :show-labels="false"
                      label="text"
                      track-by="text"
                    >
                    </multiselect> -->
                    <Select4
                      v-model="locationTypeId"
                      :key="locationTypeId"
                      :classProp="errors.length > 0 ? 'is-invalid' : null"
                      placeholder="Select region"
                      :options="{
                        isSearch: true,
                        value: 'id',
                        all: true,
                        label: 'text',
                        data: getLocationTypes,
                        fields: [{ field: 'text', label: 'text' }],
                      }"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  :name="$t('latitudes')"
                  #default="{ errors }"
                  rules="required|regex:^([0-9\.]+)$"
                >
                  <b-form-group>
                    <label
                      >{{ $t("latitudes") }}<span class="required">*</span>
                    </label>

                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      v-model="latitudes"
                      @change="forceRerender"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  :name="$t('longitudes')"
                  #default="{ errors }"
                  rules="required|regex:^([0-9\.]+)$"
                >
                  <b-form-group>
                    <label
                      >{{ $t("longitudes") }}<span class="required">*</span>
                    </label>

                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      v-model="longitudes"
                      @change="forceRerender"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="6">
                <validation-provider
                  :name="$t('detailedAddress')"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <label
                      >{{ $t("detailedAddress")
                      }}<span class="required">*</span>
                    </label>

                    <b-form-input
                      :state="errors.length > 0 ? false : null"
                      v-model="address"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider
                  :name="$t('phone')"
                  #default="{ errors }"
                  rules="regex:^([0-9]+)$"
                >
                  <b-form-group>
                    <label>{{ $t("phone") }}</label>

                    <b-form-input
                      v-model="phone"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <b-form-group :label="$t('contactName')">
                  <b-form-input v-model="contactName" />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group :label="$t('gender')">
                  <b-row class="pw-1">
                    <b-col cols="4">
                      <b-form-radio
                        v-model="gender"
                        name="some-radios"
                        value="1"
                      >
                        {{ $t("Male") }}
                      </b-form-radio>
                    </b-col>
                    <b-col cols="4">
                      <b-form-radio
                        v-model="gender"
                        name="some-radios"
                        value="2"
                      >
                        {{ $t("Female") }}
                      </b-form-radio>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col id="form-map" v-if="isMap" cols="5">
            <web-map
              class="map"
              @marker="addMarker"
              :location="{ lng: longitudes, lat: latitudes }"
            />
          </b-col>
        </b-row>
      </validation-observer>
      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="mr-1 round"
          @click="modalShow = false"
        >
          {{ $t("cancel") }}
        </b-button>

        <b-button
          :disabled="isDisabledSubmit"
          variant="primary"
          size="sm"
          @click="handleOk"
          class="round"
        >
          {{ isAdmin ? $t("approved") : $t("save") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import Select2 from "v-select2-component";
import WebMap from "./WebMap.vue";

export default {
  name: "Location",
  props: {
    idUser: {
      type: String,
      default: "",
    },
  },
  components: {
    vSelect,
    FeatherIcon,
    ValidationProvider,
    ValidationObserver,
    Select2,
    WebMap,
  },
  computed: {
    ...mapState("masterData", ["regions", "countries", "users"]),
    ...mapGetters("masterData", ["getLocationTypes"]),
  },
  mounted() {
    this.fetchLocation();
    this.fetchLocationOption();
    //get masterData
    this.fetchRegion();
    this.fetchCountries();
    this.fetchUsers();
    this.fetchLocationTypes();
    this.loadCompany();

    if (["ADMIN", "ADMIN_SALE"].includes(this.userData.role)) {
      this.fields.splice(1, 0, {
        key: "user_id",
        sortable: true,
        label: "USER ID",
        class: "maxw-200",
      });
    }
  },
  watch: {
    perPage: function (n, o) {
      this.fetchLocation();
    },
    searchQuery: function (n, o) {
      if (!this.searchQuery) {
        this.fetchLocation();
      }
    },
    currentPage: function (n, o) {
      this.fetchLocation();
    },
    location: function (n, o) {
      this.latitudes = this.location.latitude;
      this.longitudes = this.location.longitude;
      this.forceRerender();
    },
    company_id: function (n, o) {
      this.loadCustomerList();
    },
    "$i18n.locale": function (newVal, oldVal) {
      this.renderComponent = false;
      this.fields = [];
      this.$nextTick(() => {
        // Add the component back in
        this.fields = [
          {
            key: "modified_date",
            sortable: true,
            label: this.$i18n.t("date"),
          },
          {
            key: "abbreviations",
            sortable: false,
            label: this.$i18n.t("name"),
          },
          {
            key: "detail_address",
            label: this.$i18n.t("address"),
            sortable: false,
          },
          {
            key: "STATUS",
            label: this.$i18n.t("status"),
            sortable: false,
          },

          {
            key: "actions",
            label: this.$i18n.t("actions"),
          },
        ];

        this.renderComponent = true;
      });
    },
  },
  methods: {
    ...mapActions("masterData", [
      "fetchRegion",
      "fetchCountries",
      "fetchUsers",
      "fetchLocationTypes",
    ]),
    async loadRegion() {
      this.$loading.show();
      await this.fetchRegion();
      this.$loading.hide();
    },
    loadCustomerList() {
      this.$loading.show();

      useJwt
        .get("wr1?objectType=CustomerListCompany", {
          params: { search: this.company_id },
        })
        .then((response) => {
          this.customer_list_options = response.data.result;
          this.user = this.customer_list_options.filter(
            (e) => e.user_type == 2
          )[0];
        })
        .finally(() => this.$loading.hide());
    },

    loadCompany() {
      this.$loading.show();
      useJwt
        .get("masterData?data=Company", {})
        .then((response) => {
          // acronym
          this.company_list = response.data.result.map((obj) => {
            obj.text = obj.acronym + " - " + obj.text || obj.name;
            obj.id = obj.code;
            return obj;
          });
        })
        .finally(() => this.$loading.hide());
    },
    formatOption(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.text || obj.name;
        obj.id = obj.code;
        return obj;
      });
      return mapData;
    },
    onSearch() {
      if (this.searchQuery) {
        this.$loading.show();
        this.fetchLocation();
      }
    },

    fetchLocationOption: function () {
      this.$loading.show();

      useJwt
        .get("masterData", { params: { data: "Location" } })
        .then((response) => {
          this.locations = response.data.result;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              icon: "XIcon",
              variant: "danger",
              text: this.$i18n.t("errorSystem"),
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    fetchLocation: function () {
      useJwt
        .get("userLocations", {
          params: {
            search: this.searchQuery.trim(),
            page: this.currentPage,
            pageSize: this.perPage,
            userId: this.idUser || "",
          },
        })
        .then((response) => {
          this.items = response.data.result;
          this.totalRows = response.data.meta.total;
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("error"),
              text: this.$i18n.t("errorSystem"),
              icon: "XIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },

    Edit(item) {
      if (item.status == 0) {
        this.Id = item.id;
        this.anotherLocation = true;
        this.abbreviations = item.abbreviations;
        this.locationInput = item.location;
        this.longitudes = item.longitude;
        this.createdBy = item.created_by;

        this.latitudes = item.latitude;
        this.region = this.regions.find((e) => e.text === item.region_name);
        this.locationTypeId = this.getLocationTypes.find(
          (e) => e.id === item.location_type_id
        );
        this.address = item.detail_address;
        this.phone = item.phone;
        this.contactName = item.contact_name;
        this.gender = item.gender;
        this.user =
          this.users.length > 0
            ? this.users.find((e) => e.user_id == item.user_id)
            : {};
      }
      this.isDisabledSubmit = false;
      this.isShowEdit = false;

      this.modal_title = this.$i18n.t("editLocation");
      if (this.userData.role == "ADMIN" || this.userData.role == "ADMIN_SALE") {
        this.modal_title = this.$i18n.t("approvedNewLocation");
        this.isShowEdit = false;

        this.isAdmin = true;
      }

      this.modalShow = true;
    },
    New() {
      this.modal_title = this.$i18n.t("newLocation");
      this.modalShow = true;
      this.isShowEdit = true;
      if (this.userData.role == "ADMIN" || this.userData.role == "ADMIN_SALE") {
        this.isAdmin = true;
      }

      this.resetForm();
    },
    async Delete(item, index, button) {
      this.currentItem = item;
      var res = await this.$bvModal.msgBoxConfirm(
        this.$i18n.t("areYouDelete") + "?",
        {
          title: this.$i18n.t("deleteLocation"),
          size: "sm",
          okTitle: this.$i18n.t("ok"),
          cancelTitle: this.$i18n.t("cancel"),
        }
      );
      if (res) {
        useJwt
          .delete(`userLocations`, { params: { id: item.id } })
          .then((response) => {
            this.fetchLocation();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyDeleted"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    async handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.simpleRulesModal
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("error"),
            text: this.$i18n.t("notifyFormError"),
            icon: "XIcon",
            variant: "danger",
          },
        });
        return;
      }
      this.isDisabledSubmit = true;
      if (this.modal_title == this.$i18n.t("newLocation")) {
        const data = this.anotherLocation
          ? {
              abbreviations: this.abbreviations,
              contactName: this.contactName,

              detailAddress: this.address,
              gender: Number(this.gender).toString(),
              latitude: this.latitudes,
              location: this.locationInput,
              locationType: Number(this.anotherLocation).toString(),
              longitude: this.longitudes,
              locationTypeId: this.locationTypeId.id,
              phone: this.phone,
              regionId: this.region.code,
              userId: this.user.code || this.userData.username,
            }
          : {
              abbreviations: this.location.name,
              locationId: this.location.id,
              locationType: Number(this.anotherLocation).toString(),
              userId: this.user.code || this.userData.username,
            };

        useJwt
          .post("userLocations", data)
          .then((response) => {
            if (response.data.result == "0")
              return this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("error"),
                  text: this.$i18n.t("alreadyData"),
                  icon: "XIcon",
                  variant: "danger",
                },
              });
            this.fetchLocation();
            this.modalShow = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyAdded"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.isDisabledSubmit = false;
          });
      } else {
        const data = {
          id: this.Id,
          abbreviations: this.abbreviations,
          contactName: this.contactName,
          createdBy: this.createdBy,
          detailAddress: this.address,
          gender: Number(this.gender).toString(),
          latitude: this.latitudes,
          location: this.locationInput,
          locationType: Number(this.anotherLocation).toString(),
          longitude: this.longitudes,
          phone: this.phone,
          regionId: this.region.code,
          userId: this.user?.user_id || this.userData.username,
          locationTypeId: this.locationTypeId.code,
        };

        useJwt
          .put(`userLocations`, data)
          .then((response) => {
            this.fetchLocation();
            this.modalShow = false;

            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("success"),
                text: this.$i18n.t("successfullyUpdated"),

                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("error"),
                text: this.$i18n.t("errorSystem"),
                icon: "XIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.isDisabledSubmit = false;
          });
      }
    },
    readonly() {
      return !(this.modal_title == this.$i18n.t("newLocation"));
    },
    buttomDisabled(item) {
      var isDisabled = false;

      switch (this.userData.role) {
        case "CLIENT_ROOT":
          if (item.status !== 1) {
            isDisabled = true;
          }

          break;
        case "CLIENT":
          if (item.status !== 1 && item.user_id === this.userData.username) {
            isDisabled = true;
          }
          break;
        default:
          if (item.location_type === 1 && item.status === 0) {
            isDisabled = true;
          }

          break;
      }

      return isDisabled;
    },
    async forceRerender() {
      // Remove my-component from the DOM

      this.isMap = false;
      await this.$nextTick();
      // Add my-component from the DOM

      this.isMap = true;
    },

    resetForm() {
      this.company_id = "";
      this.location = {};
      this.anotherLocation = false;
      this.abbreviations = "";
      this.longitudes = "";
      this.latitudes = "";
      this.region = "";
      this.locationTypeId = "";
      this.address = "";
      this.phone = "";
      this.contactName = "";
      this.gender = 1;
      this.locationInput = "";
      this.user = {};
    },
    addMarker(data) {
      this.longitudes = data.lng;
      this.latitudes = data.lat;
    },
  },

  data() {
    return {
      isDisabledSubmit: false,
      customer_list_options: [],
      customer_list: [],
      company_list: [],
      company_id: "",
      isMap: true,
      userData: JSON.parse(localStorage.getItem("userData")),
      modalShow: false,
      items: [],
      perPageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      searchQuery: "",
      currentItem: {},
      anotherLocation: false,
      modal_title: this.$i18n.t("newLocation"),
      locations: [],
      location: {},
      isShowEdit: true,

      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      // dataInput
      Id: "",
      abbreviations: "",
      longitudes: "",
      latitudes: "",
      region: "",
      locationTypeId: "",
      address: "",
      phone: "",
      contactName: "",
      gender: 1,
      locationInput: "",
      user: "",
      isAdmin: false,

      searchUserId: "",
      createdBy: "",
      selectUser: { text: "Created By" },
      fields: [
        {
          key: "modified_date",
          sortable: true,
          label: this.$i18n.t("date"),
        },
        {
          key: "abbreviations",
          sortable: false,
          label: this.$i18n.t("name"),
        },
        {
          key: "detail_address",
          label: this.$i18n.t("address"),
          sortable: false,
        },
        {
          key: "STATUS",
          label: this.$i18n.t("status"),
          sortable: false,
        },

        {
          key: "actions",
          label: this.$i18n.t("actions"),
          tdClass: "actions-td",
        },
      ],
    };
  },
  beforeDestroy() {
    this.$store.commit("masterData/RESET_STATE");
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style>
.select2-selection--single {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}
.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}
.select2-selection__arrow {
  background: none;
  display: none !important;
}
.status-succes {
  background: rgba(40, 199, 111, 0.12);
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 1px;
  padding-bottom: 1px;

  font-weight: 600;
  color: #28c76f;
}
.status-witing {
  background: rgba(254, 224, 0, 0.33);
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 1px;
  padding-bottom: 1px;

  font-weight: 600;
  color: #fab318;
}
#form-map {
  position: relative;
}

.select2-dropdown--below {
  /*  top: -2.8rem;  */
  /*your input height*/
}
.vue-map-container {
  height: 550px !important;
}
</style>
